<template>
  <section class="continut">
    <div class="container py-4">
      <div class="row align-items-top">
        <div class="col-md-6 col-12" style="padding: 0;">
          <div>
            <h2>De ce este laptele <br class="d-block d-md-none"> matern cel mai bun?</h2>
            <p class="lapte-matern">Laptele matern este deosebit de complex. Compoziția laptelui matern este unică, dată
              de numeroși nutrienți și componente bioactive care fac din el cea mai bună hrană
              pentru copilul tău în primele 6 luni, contribuind la dezvoltarea lui armonioasă, dar
              și la construirea și creșterea imunității.
            </p>
          </div>
        </div>
        <div class="col-md-6 col-12 text-center">
          <h3 class="ce-contine">Ce conține laptele matern?</h3>
          <img src="../../assets/images/image-secretele-laptelui/drop-two.png">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
}
</script>

<style scoped lang="scss">
.continut {
  color: #17479E;
  padding: 60px 0;
  background: #F2F0ED;
  height: 521px;

  .container {
    position: relative;
    padding: 0 !important;

    .bk-dark {
      position: absolute;
      left: -50%;
      height: 100%;
      background: #17479E;
      width: 50%;
      top: 0;
    }
  }

  h2 {
    font-size: 40px;
    font-weight: 700;
    line-height: 42px;
    margin-bottom: 40px;
  }

  h3 {
    font-size: 20px;
    font-weight: 700;
    text-align: center;
  }

  p {
    color: #17479E;
  }

  .arrow-round {
    position: relative;
    bottom: -120px;
  }
}

@media screen and (max-width: 768px) {
  .py-4 img{
    width: 290px;
  }
  .continut {
    height: auto;
    padding: 60px 20px;
    h2{
      font-size: 26px;
      line-height: 30px;
      text-align: center;
    }
  }

}

@media screen and (max-width: 425px){
  .lapte-matern{
    text-align: center;
    margin-bottom: 40px;
  }
  .ce-contine{
    font-size: 26px !important;
  }

}
</style>
